/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ sessions: NonNullable<unknown>, volumeText: NonNullable<unknown> }} Today_Moment_LineInputs */

const en_us2_today_moment_line = /** @type {(inputs: Today_Moment_LineInputs) => LocalizedString} */ (i) => {
	if ((i?.sessions === 1 || i?.sessions === "1")) return /** @type {LocalizedString} */ (`1 workout · ${i?.volumeText}`);
	return /** @type {LocalizedString} */ (`${i?.sessions} workouts · ${i?.volumeText}`)
	
};

const pt_br2_today_moment_line = /** @type {(inputs: Today_Moment_LineInputs) => LocalizedString} */ (i) => {
	if ((i?.sessions === 1 || i?.sessions === "1")) return /** @type {LocalizedString} */ (`1 treino · ${i?.volumeText}`);
	return /** @type {LocalizedString} */ (`${i?.sessions} treinos · ${i?.volumeText}`)
	
};

const es_419_today_moment_line = /** @type {(inputs: Today_Moment_LineInputs) => LocalizedString} */ (i) => {
	if ((i?.sessions === 1 || i?.sessions === "1")) return /** @type {LocalizedString} */ (`1 entrenamiento · ${i?.volumeText}`);
	return /** @type {LocalizedString} */ (`${i?.sessions} entrenamientos · ${i?.volumeText}`)
	
};

const pt_pt2_today_moment_line = /** @type {(inputs: Today_Moment_LineInputs) => LocalizedString} */ (i) => {
	if ((i?.sessions === 1 || i?.sessions === "1")) return /** @type {LocalizedString} */ (`1 treino · ${i?.volumeText}`);
	return /** @type {LocalizedString} */ (`${i?.sessions} treinos · ${i?.volumeText}`)
	
};

const fr_fr2_today_moment_line = /** @type {(inputs: Today_Moment_LineInputs) => LocalizedString} */ (i) => {
	if ((i?.sessions === 1 || i?.sessions === "1")) return /** @type {LocalizedString} */ (`1 séance · ${i?.volumeText}`);
	return /** @type {LocalizedString} */ (`${i?.sessions} séances · ${i?.volumeText}`)
	
};

const de_de2_today_moment_line = /** @type {(inputs: Today_Moment_LineInputs) => LocalizedString} */ (i) => {
	if ((i?.sessions === 1 || i?.sessions === "1")) return /** @type {LocalizedString} */ (`1 Training · ${i?.volumeText}`);
	return /** @type {LocalizedString} */ (`${i?.sessions} Trainings · ${i?.volumeText}`)
	
};

const it_it2_today_moment_line = /** @type {(inputs: Today_Moment_LineInputs) => LocalizedString} */ (i) => {
	if ((i?.sessions === 1 || i?.sessions === "1")) return /** @type {LocalizedString} */ (`1 allenamento · ${i?.volumeText}`);
	return /** @type {LocalizedString} */ (`${i?.sessions} allenamenti · ${i?.volumeText}`)
	
};

/**
* | sessions | output |
* | --- | --- |
* | "1" | "1 workout · {volumeText}" |
* | * | "{sessions} workouts · {volumeText}" |
*
* @param {Today_Moment_LineInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const today_moment_line = /** @type {((inputs: Today_Moment_LineInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Today_Moment_LineInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_today_moment_line(inputs)
	if (locale === "es-419") return es_419_today_moment_line(inputs)
	if (locale === "pt-PT") return pt_pt2_today_moment_line(inputs)
	if (locale === "fr-FR") return fr_fr2_today_moment_line(inputs)
	if (locale === "de-DE") return de_de2_today_moment_line(inputs)
	if (locale === "it-IT") return it_it2_today_moment_line(inputs)
	return en_us2_today_moment_line(inputs)
});
export { today_moment_line as "today.moment_line" }